import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-12f406aa"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ads-text-div"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  class: "title-left"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "black-video-list-div"
};
const _hoisted_6 = {
  class: "title"
};
const _hoisted_7 = {
  class: "page"
};
import VideoList from "../../components/VideoList.vue";
import api from "@/api/shipin2/index.js";
import { watch, onMounted, ref, provide, inject, computed, onActivated, onDeactivated, onBeforeUnmount } from "vue";
import { useRouter, useRoute, onBeforeRouteLeave } from "vue-router";
import { store } from "../../utils/store.js";
import { getAdsId } from '@/utils';
import { ensureCategory, ensureCateList } from '../../utils/dataCache.js';
import { nextTick } from 'vue';
export default {
  __name: 'index',
  setup(__props) {
    const loading = inject('loading');
    const oldScrollTop = ref(0);
    const isHide = ref(false);
    let shouldRestoreAfterReturn = false;
    let lastHomeRouteFullPath = '';
    const getScrollTopValue = () => window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const scrolling = () => {
      const scrollTop = getScrollTopValue();
      const scrollStep = scrollTop - oldScrollTop.value;
      if (scrollTop < 300) return;
      oldScrollTop.value = scrollTop;
      isHide.value = scrollStep >= 0;
    };
    let scrollListenerAttached = false;
    const attachScrollListener = () => {
      if (scrollListenerAttached) return;
      window.addEventListener('scroll', scrolling);
      scrollListenerAttached = true;
    };
    const detachScrollListener = () => {
      if (!scrollListenerAttached) return;
      window.removeEventListener('scroll', scrolling);
      scrollListenerAttached = false;
    };
    const router = useRouter();
    const route = useRoute();
    lastHomeRouteFullPath = route.fullPath;
    const videoList = ref([]);
    const homeVideoList = ref(store.homeVideoList.length ? [...store.homeVideoList] : []);
    const currentPage = ref(1);
    console.log('const-currentPage', currentPage.value);
    const total = ref(100); // 这是个bug, 这里的值不能设置0，如果0了，影响当前分页currentPage的值每次渲染设置1了。
    const current = ref({});

    // 保存网址方法
    const openSaveTheUrl = ref(() => {});
    provide('openSaveTheUrl', openSaveTheUrl);
    const onload = () => {
      openSaveTheUrl.value();
    };

    // // 首页弹窗广告 默认展示第一个 关闭当前展示下一个 当前为最后一个关闭弹窗
    // const popAd = ref({
    //   show: false,
    //   showIndex: 0,
    //   list: computed(() => {
    //     const filterList = store.adsList.filter(v => v.class_id == 5)
    //     return filterList
    //   }),
    //   close: (index) => {
    //     popAd.value.showIndex = index + 1
    //     if (index === popAd.value.list.length - 1) {
    //       popAd.value.show = false
    //     }
    //   }
    // })

    // watch(() => popAd.value.list, (v) => {
    //   if (!sessionStorage.getItem('popAd')) {
    //     if (v.length > 0) {
    //       popAd.value.show = true
    //     }

    //     openSaveTheUrl.value()
    //     sessionStorage.setItem('popAd', 0)
    //   }
    // })

    const goPage = ref();

    // 查询分类列表（带缓存）
    const queryClassificationList = async () => {
      await ensureCategory();
    };

    // 跳转
    const jump = () => {
      if (!goPage.value) return;
      currentPage.value = goPage.value;
      if (route.query.title === 'hot' || route.query.title === '热门') {
        queryVideoList();
      } else if (route.query.title === 'last') {
        queryVideoList2();
      } else {
        queryVideoClassificationList(current.value);
      }
    };
    const scrollToTop = () => {
      let sTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (sTop > 5) {
        window.requestAnimationFrame(scrollToTop);
        window.scrollTo(0, sTop - sTop / 8);
      }
    };
    const queryPage = () => {
      // 保存当前的分页
      console.log('分类查询currentPage.value', currentPage.value);
      store.setHomeIndexCurrent(currentPage.value);
      console.log('save分页', store.homeIndexCurrent);
      if (route.query.type === 'hot' || route.query.title === '热门') {
        queryVideoList();
      } else if (route.query.type === 'last') {
        queryVideoList2();
      } else {
        //console.log('queryPage', current.value)
        queryVideoClassificationList(current.value);
      }
      scrollToTop();
      store.setHomeScrollTop(0);
    };

    // 通过分类查询视频列表
    const queryVideoClassificationList = async item => {
      current.value = item;
      const res = await api.queryVideoClassificationList({
        id: current.value.id ?? 0,
        page: currentPage.value,
        size: 10,
        type: item.classify ? 'cate' : current.value.type,
        only_topic: current.value.only_topic,
        cate: item.classify
      });

      // currentPage.value = store.homeIndexCurrent // 重新设置一下，咋有重置为1了？？
      // console.log('currentPage.value', currentPage.value)

      videoList.value = res.data;
      total.value = res.data.total;
    };

    // 最近更新列表
    const recentList = ref([]);

    // 查询首页视频列表
    const useCachedHomeVideoList = () => {
      if (store.homeDataLoaded && store.homeVideoList.length) {
        homeVideoList.value = [...store.homeVideoList];
        return true;
      }
      return false;
    };
    const queryHomepageVideoList = async params => {
      if (!params && useCachedHomeVideoList()) {
        return;
      }
      const res = await api.queryHomeVideo();
      res.data.map(v => {
        if (v.list.length > 10) {
          v.list = v.list.slice(0, 10);
        }
      });
      if (params?.last) {
        recentList.value = res.data.find(v => ['最近更新'].includes(v.title)).list;
      } else {
        let newList = res.data;
        [newList[0], newList[1]] = [newList[1], newList[0]];
        const filtered = newList.filter(v => !['黑料'].includes(v.title)).filter(v => v.list.length);
        homeVideoList.value = filtered;
        store.setHomeVideoList(filtered);
      }
    };
    const cateList = ref([]);

    // 查询分类列表（cate）带缓存
    const getCateList = async () => {
      await ensureCateList();
      cateList.value = store.cateList;
    };

    // 查询热门视频
    const queryVideoList = async () => {
      // queryHomepageVideoList({ last: true })
      const res = await api.queryVideoClassificationList({
        id: 0,
        page: currentPage.value,
        size: 10,
        type: 'hot'
      });
      videoList.value = res.data;
      total.value = res.data.total;
    };

    // 查询最新更新
    const queryVideoList2 = async () => {
      // queryHomepageVideoList({ last: true })
      const res = await api.queryVideoClassificationList({
        id: 0,
        page: currentPage.value,
        size: 10,
        type: 'last'
      });
      videoList.value = res.data;
      total.value = res.data.total;
    };

    // 初始化查询
    const initQuery = async () => {
      // currentPage.value = 1
      // 如果保存的分页数据，则获取
      console.log('initQuery', currentPage.value);
      console.log('获取分页', store.homeIndexCurrent);
      store.setHomeScrollTop(0);
      if (store.homeIndexCurrent > 1) {
        currentPage.value = store.homeIndexCurrent;
        await nextTick(); // 等待界面更新
      }

      if (route.query.type === 'hot' || route.query.title === '热门') {
        await queryVideoList();
      } else if (route.query.type === 'last') {
        await queryVideoList2();
      } else if (route.query.title) {
        await queryClassificationList();
        queryVideoClassificationList(categoryList.value.find(v => v.title === route.query.title));
      } else if (route.query.classify) {
        await queryClassificationList();
        await getCateList();
        queryVideoClassificationList(cateList.value.find(v => v.classify === route.query.classify));
      } else {
        queryClassificationList();
        if (!useCachedHomeVideoList()) {
          await queryHomepageVideoList();
        }
      }
      lastHomeRouteFullPath = route.fullPath;
    };
    const categoryList = computed(() => store.categoryList);
    const queryVideo = item => {
      router.push({
        path: "details",
        query: {
          id: item.id
        }
      });
    };
    const queryMoreInHome = item => {
      console.log('点击更多：queryMoreInHome', item);

      // 热门,最新
      router.push({
        path: 'home',
        query: {
          title: item.title,
          type: item.type
        }
      });
    };
    onBeforeRouteLeave(to => {
      if (to.path === '/details') {
        const current = getScrollTopValue();
        store.setHomeScrollTop(current);
        oldScrollTop.value = current;
        shouldRestoreAfterReturn = true;
        lastHomeRouteFullPath = route.fullPath;
      } else {
        shouldRestoreAfterReturn = false;
      }
    });
    onActivated(() => {
      attachScrollListener();
      requestAnimationFrame(() => {
        if (shouldRestoreAfterReturn && route.fullPath === lastHomeRouteFullPath) {
          const target = store.homeScrollTop || 0;
          oldScrollTop.value = target;
          window.scrollTo(0, target);
        } else {
          store.setHomeScrollTop(0);
          oldScrollTop.value = 0;
          window.scrollTo(0, 0);
        }
      });
    });
    onDeactivated(() => {
      const current = getScrollTopValue();
      store.setHomeScrollTop(current);
      oldScrollTop.value = current;
      detachScrollListener();
    });
    onBeforeUnmount(() => {
      detachScrollListener();
    });
    watch(route, to => {
      if (to.path !== '/home') {
        return;
      }
      const returningToSameRoute = shouldRestoreAfterReturn && to.fullPath === lastHomeRouteFullPath;
      shouldRestoreAfterReturn = false;
      if (returningToSameRoute) {
        return;
      }
      initQuery();
    });
    const reportAds = async () => {
      await api.reportAds({
        ad_ids: getAdsId('1,5,6,11,12', store.adsList)
      });
    };
    onMounted(() => {
      attachScrollListener();
      if (store.adsList.length) {
        reportAds();
      }
      // loading.value = true
      console.log('start_onMounted');
      Promise.all([initQuery()]).then(v => {
        console.log('onMounted-Promise.all', v);
        // loading.value = false
      });
    });

    return (_ctx, _cache) => {
      const _component_CommonHeader = _resolveComponent("CommonHeader");
      const _component_AdsPictures = _resolveComponent("AdsPictures");
      const _component_van_icon = _resolveComponent("van-icon");
      const _component_van_pagination = _resolveComponent("van-pagination");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_cell_group = _resolveComponent("van-cell-group");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_CommonHeader), _createVNode(_component_AdsPictures, {
        type: 6
      }), _createElementVNode("div", _hoisted_1, [_createVNode(_component_AdsPictures, {
        type: 11
      })]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...homeVideoList.value.filter(item => item.type == 'last'), ...homeVideoList.value.filter(item => item.type != 'last')], (item, index) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "black-video-list-div",
          key: index
        }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", null, _toDisplayString(_unref(store).isDev() ? 'title' : item.title), 1), _createVNode(_component_AdsPictures, {
          type: 12
        })]), item.id !== 0 || item.type === 'hot' || item.type === 'last' ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: $event => queryMoreInHome(item),
          class: "more"
        }, [_createTextVNode("更多 "), _createVNode(_component_van_icon, {
          name: "arrow"
        })], 8, _hoisted_4)) : _createCommentVNode("", true)]), _createVNode(VideoList, {
          list: item.list,
          onQuery: queryVideo
        }, null, 8, ["list"])])), [[_vShow, [_ctx.$route.query.title, _ctx.$route.query.classify].every(v => !v)]]);
      }), 128)), _withDirectives(_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", null, _toDisplayString(_unref(store).isDev() ? 'title' : _ctx.$route.query.title || _ctx.$route.query.classify), 1)]), _createVNode(_Transition, {
        name: "fade",
        mode: "out-in"
      }, {
        default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(VideoList, {
          list: videoList.value.list,
          onQuery: queryVideo
        }, null, 8, ["list"])])]),
        _: 1
      }), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", null, [_createVNode(_component_van_pagination, {
        modelValue: currentPage.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => currentPage.value = $event),
        "total-items": total.value,
        "force-ellipses": "",
        "items-per-page": 10,
        "show-page-size": 3,
        onChange: _cache[1] || (_cache[1] = $event => queryPage())
      }, {
        "prev-text": _withCtx(() => [_createVNode(_component_van_icon, {
          name: "arrow-left"
        })]),
        "next-text": _withCtx(() => [_createVNode(_component_van_icon, {
          name: "arrow"
        })]),
        _: 1
      }, 8, ["modelValue", "total-items"]), _createElementVNode("div", null, _toDisplayString(currentPage.value) + "/" + _toDisplayString(Math.ceil(total.value / 10)), 1)]), _createVNode(_component_van_cell_group, {
        inset: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_van_field, {
          modelValue: goPage.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => goPage.value = $event),
          type: "digit",
          center: "",
          clearable: "",
          placeholder: "跳转页",
          border: ""
        }, {
          button: _withCtx(() => [_createVNode(_component_van_button, {
            size: "small",
            type: "primary",
            onClick: jump
          }, {
            default: _withCtx(() => [_createTextVNode("跳转")]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      })])], 512), [[_vShow, [_ctx.$route.query.title, _ctx.$route.query.classify].some(v => v)]]), _createVNode(_component_AdsPictures, {
        type: 5,
        onOnload: onload
      }), _ctx.$route.path === '/home' && _ctx.$route.query.title != undefined ? (_openBlock(), _createBlock(_component_AdsPictures, {
        key: 0,
        type: 26,
        number: 1,
        random: 1
      })) : _createCommentVNode("", true)], 64);
    };
  }
};